import { UserCircle, ShieldCheck } from 'lucide-react'
import { Routes, Route, Navigate } from 'react-router-dom'

import VerticalNavTabs from '@components/VerticalNavTabs'
import Breadcrumbs from '@components/Breadcrumbs'

import Profile from './Profile'
import SecuritySettings from './SecuritySettings'

const Settings = () => (
  <>
    <Breadcrumbs>
      <Breadcrumbs.Link label='Settings' to='/students/settings' />
    </Breadcrumbs>

    <div className='flex w-full h-[calc(100vh-64px)]'>
      <VerticalNavTabs>
        <VerticalNavTabs.Link
          to='profile'
          label='Profile'
          icon={<UserCircle size={16} />}
        />

        <VerticalNavTabs.Link
          to='security-settings'
          label='Security settings'
          icon={<ShieldCheck size={16} />}
        />
      </VerticalNavTabs>

      <Routes>
        <Route index element={<Navigate to='profile' />} />
        <Route path='profile' element={<Profile />} />
        <Route path='security-settings' element={<SecuritySettings />} />
      </Routes>
    </div>
  </>
)

export default Settings
